import React, {useEffect} from "react"
import Header from "../components/Header/Header"
import Hero from "../components/Hero/Hero"
import Footer from "../components/Footer/Footer"
import Advert from "../components/Advert/Advert"
import LatestContent from "../components/LatestContent/LatestContent"
import Promo from "../components/Promo/Promo"
import ArticleCarousel from "../components/Carousel/Carousel"
import MoreContent from "../components/MoreContent/MoreContent"
import Quote from "../components/Quote/Quote"
import HeroText from "../components/HeroText/HeroText"
import IsNotDomestic from "../helpers/IsNotDomestic"
import Map from "../components/Map/Map"
import "../styles/style.scss"
// import MediaQuery from 'react-responsive';

import GlobalData  from '../data/global.js';
import Content from '../data/content.js'
import { trackCustomEvent } from "../helpers/tracking"

// markup
const IndexPage = () => {
  let progress25Tracked = false;
	let progress50Tracked = false;
	let progress75Tracked = false;
	let progress100Tracked = false;
	let pereviousScrollPercentage = 0

  useEffect( () => {
	  window.addEventListener('scroll', onScroll)
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	},[])

  function onScroll(){

    let articleHeight = document.body.scrollHeight;
    let viewPort= window.innerHeight;
    var percentage = ((getCurrentPosition() + viewPort) - 0)/articleHeight * 100;
    var minMaxPercentage = Math.min(100, Math.max(pereviousScrollPercentage, percentage));

		if(minMaxPercentage >= 25){
			if(!progress25Tracked) {
          trackScrollProgress(25);
				  progress25Tracked = true;				
			}
		}

		if(minMaxPercentage >= 50){
			if(!progress50Tracked) {
          trackScrollProgress(50);
          progress50Tracked = true;				
			}
		}
		
		if(minMaxPercentage >= 75){
			if(!progress75Tracked) {
          trackScrollProgress(75);
				  progress75Tracked = true;
			}
		}

		if(minMaxPercentage >= 100){
			if(!progress100Tracked) {
        trackScrollProgress(100);
				progress100Tracked = true;					
			}
		}
		
		pereviousScrollPercentage= minMaxPercentage

  }

  function trackScrollProgress(progress){
		let trackObject = {
			'category': GlobalData.tracking.gaCategory,
			'action': "Scroll depth",
			'label': progress + "%"
		}
		trackCustomEvent(trackObject)
	}

  function getCurrentPosition (){
		return Math.abs(( window.scrollY || document.body.scrollTop || document.documentElement.scrollTop));
	}
  return (
    <>
		<Header isSticky={true}/>
		<Hero content={Content.Hero} cdnBase={GlobalData.VideoCDNPath}/>
		<HeroText content={Content.HeroText} cdnBase={GlobalData.VideoCDNPath}/>
		<LatestContent content={Content.LatestContent} GlobalData={GlobalData}/>
		<IsNotDomestic>
			<Advert adData={GlobalData.advertising} column="delta1"/>
		</IsNotDomestic>
		<Quote content={Content.Quote} GlobalData={GlobalData}/>
		<ArticleCarousel content={Content.Carousel} GlobalData={GlobalData}/>
		<Promo content={Content.PromoContent} GlobalData={GlobalData}/>
		<Map content={Content.Map} GlobalData={GlobalData}/>
		<MoreContent content={Content.MoreContent} GlobalData={GlobalData}/>
		<Footer/>
    </>
  )
}

export default IndexPage
